var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1587 8.28728C19.0177 8.39667 16.5284 9.79936 16.5284 12.9183C16.5284 16.5259 19.696 17.8022 19.7908 17.8338C19.7762 17.9116 19.2876 19.5817 18.1207 21.2834C17.0802 22.7809 15.9935 24.276 14.3405 24.276C12.6874 24.276 12.262 23.3157 10.3536 23.3157C8.49391 23.3157 7.83268 24.3076 6.3206 24.3076C4.80852 24.3076 3.75346 22.9219 2.54039 21.2202C1.13528 19.2219 0 16.1175 0 13.1712C0 8.44529 3.07278 5.93893 6.09695 5.93893C7.70384 5.93893 9.04332 6.99399 10.0522 6.99399C11.0124 6.99399 12.5099 5.87573 14.338 5.87573C15.0309 5.87573 17.5202 5.93893 19.1587 8.28728ZM13.4702 3.87501C14.2262 2.97797 14.761 1.7333 14.761 0.488631C14.761 0.31603 14.7464 0.140998 14.7148 0C13.4848 0.046189 12.0213 0.819247 11.1388 1.8427C10.446 2.63034 9.79936 3.87501 9.79936 5.1367C9.79936 5.32632 9.83096 5.51594 9.84555 5.57671C9.92334 5.5913 10.0498 5.60832 10.1762 5.60832C11.2798 5.60832 12.6679 4.86929 13.4702 3.87501Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.11719c12fc13d9f771373f2da1d174e0.svg";
export { ForwardRef as ReactComponent };